import { render, staticRenderFns } from "./NolaNovelDelinkConfirm.vue?vue&type=template&id=1e131a90&scoped=true"
import script from "./NolaNovelDelinkConfirm.vue?vue&type=script&lang=ts"
export * from "./NolaNovelDelinkConfirm.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelDelinkConfirm.vue?vue&type=style&index=0&id=1e131a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e131a90",
  null
  
)

export default component.exports